import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=17076183&lang=scss&scoped=true"

import exportComponent from "D:\\WorkPlace\\MINE\\dataleading3.0\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17076183"]])

export default __exports__